import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5b7f2e29")

_pushScopeId("data-v-5b7f2e29")
const _hoisted_1 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_2 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_3 = {
  key: 2,
  style: {"color":"red"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_dialog_shell = _resolveComponent("dialog-shell")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_dialog_shell, {
      title: _ctx.$wordList.ProperAllTextEditApartment,
      onClose: _ctx.close,
      onSubmit: _ctx.submit,
      footerType: "customize"
    }, {
      footer: _withId(() => [
        _createVNode(_component_el_row, { class: "width100per" }, {
          default: _withId(() => [
            _createVNode(_component_el_col, {
              span: 6,
              class: "justify-start"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_button, {
                  type: "danger",
                  onClick: _ctx.resetRoom
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$wordList.Reset), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 18,
              class: "justify-end"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_button, { onClick: _ctx.close }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootCancel), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _ctx.submit
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootSubmit), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withId(() => [
        _createVNode(_component_el_form, {
          "label-position": _ctx.$formLabelPosition,
          model: _ctx.formData,
          ref: "apartmentForm",
          rules: _ctx.rules
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$wordList.ProperAllTextApartmentName,
              prop: "AptName"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.AptName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.AptName = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$wordList.ProperAllTextCallType,
              prop: "CallType"
            }, {
              default: _withId(() => [
                _createVNode(_component_cus_select, {
                  modelValue: _ctx.formData.CallType,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.CallType = $event)),
                  style: {"width":"100%"}
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.callTypeList, (item) => {
                      return (_openBlock(), _createBlock(_component_cus_option, {
                        label: item.label,
                        value: item.value,
                        key: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$wordList.ProperAllTextSipIpCall,
              prop: "EnableIpDirect"
            }, {
              default: _withId(() => [
                _createVNode(_component_cus_select, {
                  modelValue: _ctx.formData.EnableIpDirect,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.EnableIpDirect = $event)),
                  style: {"width":"100%"}
                }, {
                  default: _withId(() => [
                    _createVNode(_component_cus_option, {
                      label: _ctx.$wordList.ProperAllTextSIPCallDev,
                      value: 0
                    }, null, 8, ["label"]),
                    _createVNode(_component_cus_option, {
                      label: _ctx.$wordList.ProperAllTextIPCallDev,
                      value: 1
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$wordList.PermissionControl
            }, {
              default: _withId(() => [
                (_ctx.isShowExpireTip)
                  ? (_openBlock(), _createBlock("p", _hoisted_1, _toDisplayString(_ctx.$wordList.ProperAllTextFeatureExpireTips), 1))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, { prop: "TempKeyPermission" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_checkbox, {
                      onChange: _ctx.changeUserQRCode,
                      modelValue: _ctx.formData.TempKeyPermission,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.TempKeyPermission = $event)),
                      "true-label": 1,
                      "false-label": 0
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextAllowedCreateQRCodes), 1)
                      ]),
                      _: 1
                    }, 8, ["onChange", "modelValue"])
                  ]),
                  _: 1
                }),
                (_ctx.isShowExpireTip3)
                  ? (_openBlock(), _createBlock("p", _hoisted_2, _toDisplayString(_ctx.$wordList.ProperAllTextFeatureExpireTips), 1))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, {
                  prop: "FamilyMemberControl",
                  style: {"margin-bottom":"0px"}
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_checkbox, {
                      onChange: _ctx.changeUserRegisterFace,
                      modelValue: _ctx.formData.RegisterFaceControl,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.RegisterFaceControl = $event)),
                      "true-label": 1,
                      "false-label": 0
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.$wordList.RegisterFaceID), 1)
                      ]),
                      _: 1
                    }, 8, ["onChange", "modelValue"])
                  ]),
                  _: 1
                }),
                (_ctx.isShowExpireTip2)
                  ? (_openBlock(), _createBlock("p", _hoisted_3, _toDisplayString(_ctx.$wordList.ProperAllTextFeatureExpireTips), 1))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, {
                  prop: "FamilyMemberControl",
                  style: {"margin-bottom":"0px"}
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_checkbox, {
                      onChange: _ctx.changeUserFamilyMember,
                      modelValue: _ctx.formData.FamilyMemberControl,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.FamilyMemberControl = $event)),
                      "true-label": 1,
                      "false-label": 0
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextFamilyMemberLimit), 1)
                      ]),
                      _: 1
                    }, 8, ["onChange", "modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { prop: "AllowCreateSlaveCnt" }, {
                  default: _withId(() => [
                    (_ctx.formData.FamilyMemberControl)
                      ? (_openBlock(), _createBlock(_component_el_input, {
                          key: 0,
                          modelValue: _ctx.formData.AllowCreateSlaveCnt,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formData.AllowCreateSlaveCnt = $event)),
                          placeholder: _ctx.$wordList.FamilyMemberAmountLimit,
                          onInput: _ctx.limitRoomNameType
                        }, null, 8, ["modelValue", "placeholder", "onInput"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["label-position", "model", "rules"])
      ]),
      _: 1
    }, 8, ["title", "onClose", "onSubmit"])
  ]))
})